import { RootState } from '@reducers';

export const selectCarQuoteComparePage = (state: RootState) => state.carQuoteComparePageReducer;
